import { render } from "./NLoadingDots.vue?vue&type=template&id=865af53a&ts=true"
import script from "./NLoadingDots.vue?vue&type=script&lang=ts"
export * from "./NLoadingDots.vue?vue&type=script&lang=ts"

import "./NLoadingDots.vue?vue&type=style&index=0&id=865af53a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__